export const REFERENCES_PATHS = {
  references: 'references',
};
